var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1203.559 -915.564 13.123 13.123"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1190.626-905.588a.63.63 0 0 1 0 .891l-2.074 2.071a.63.63 0 0 1-.891 0l-3.409-3.439-3.412 3.439a.63.63 0 0 1-.891 0l-2.071-2.074a.63.63 0 0 1 0-.891l3.439-3.409-3.439-3.412a.63.63 0 0 1 0-.891l2.074-2.076a.63.63 0 0 1 .891 0l3.409 3.444 3.413-3.439a.63.63 0 0 1 .891 0l2.075 2.074a.63.63 0 0 1 0 .891l-3.444 3.409Z"
  })));
};
export default SvgCross;